var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon1Way01 = function SvgIcon1Way01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_1_way-01_svg2__a",
    x1: 107.89,
    x2: 12.91,
    y1: 5.93,
    y2: 78.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M97.92 61.31c-1.15 0-2.08.93-2.08 2.08v14.39c0 .28-.04.56-.12.83L72.27 52.15c-.76-.86-2.08-.94-2.94-.18s-.94 2.08-.18 2.94l22.89 25.83H7.97l22.89-25.83c.76-.86.68-2.18-.18-2.94s-2.18-.68-2.94.18L4.29 78.61c-.08-.27-.12-.55-.12-.83V28.92L41.5 54.64a15.055 15.055 0 0 0 17.01 0l37.33-25.72v8.66c0 1.15.93 2.08 2.08 2.08s2.08-.93 2.08-2.08V22.22c0-3.94-3.2-7.13-7.13-7.13H7.13c-3.94 0-7.13 3.2-7.13 7.13v55.57c0 3.94 3.2 7.13 7.13 7.13h85.73c3.94 0 7.13-3.2 7.13-7.13V63.4c0-1.15-.93-2.08-2.08-2.08ZM7.13 19.25h85.73c1.64 0 2.96 1.33 2.97 2.97v1.64L56.14 51.21c-3.7 2.53-8.58 2.53-12.28 0L4.17 23.86v-1.64c0-1.64 1.33-2.96 2.97-2.97Z",
    style: {
      fill: "url(#icon_1_way-01_svg2__a)"
    }
  }));
};
export default SvgIcon1Way01;